import { render, staticRenderFns } from "./dyzpffb.vue?vue&type=template&id=60038239&"
import script from "./dyzpffb.vue?vue&type=script&lang=js&"
export * from "./dyzpffb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports